export default {
    init() {
        var check_image_size = function (container) {
            var img = container.find('img');
            if ($(window).width() > 1700) {
                if (container.hasClass('vertical')) {
                    container.removeClass('vertical').addClass('horizontal');
                }
            } else {
                if (container.hasClass('horizontal')) {
                    if (container.outerHeight() > img.outerHeight()) {
                        container.removeClass('horizontal').addClass('vertical');
                    }
                } else if (container.hasClass('vertical')) {
                    if (container.outerWidth() > img.outerWidth()) {
                        container.removeClass('vertical').addClass('horizontal');
                    }
                }
            }
        };

        var side_image_blocks = $('.banner');
        if (side_image_blocks.length) {
            side_image_blocks.each(function () {
                var container = $(this);
                var img_container = container.find('> .image');
                check_image_size(img_container);
                setTimeout(function () {
                    check_image_size(img_container);
                }, 500);
                setTimeout(function () {
                    check_image_size(img_container);
                }, 1000);
                setTimeout(function () {
                    check_image_size(img_container);
                }, 2000);
                $(window).resize(function () {
                    check_image_size(img_container);
                });
            });
        }

        // JavaScript to be fired on the home page
        var reviews = $('.hp-reviews');
        if (reviews.length) {
            var controls_container = reviews.find('.review-controls');
            reviews.find('.padder').slick({
                adaptiveHeight: true,
                appendArrows: controls_container,
                appendDots: controls_container,
                arrows: false,
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
